import actions from '../actions/carouselActions';
import createReducer from '../utils/createReducer';
import CarouselRecord from '../records/carouselRecord';

const initialState = new CarouselRecord();

const actionHandlers = {
    [actions.CHANGE_IMAGE_INDEX](state, {payload = {newIndex: 0}}) {
        return state.merge({
            index: payload.newIndex
        });
    }
};

export default createReducer(actionHandlers, initialState);
